var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "16px",
    viewBox: "0 0 16 16",
    width: "16px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#81c12c",
    transform: "translate(-480.000000, -192.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M486,197.8 L486,205.598145 L485.999914,205.598093 C486.007349,206.311236 485.532942,207.115366 484.550427,207.62066 C483.185882,208.322426 481.750973,207.979941 481.225759,207.169611 C480.700546,206.359281 481.085029,205.081106 482.449573,204.37934 C483.367261,203.907386 484.316775,203.907734 485,204.205054 L485,198 L485,194 L495,192 L495,193 L495,196 L495,204.600464 L494.999937,204.600489 C495.006283,205.313042 494.531839,206.115934 493.550427,206.62066 C492.185882,207.322426 490.750973,206.979941 490.225759,206.169611 C489.700546,205.359281 490.085029,204.081106 491.449573,203.37934 C492.367261,202.907386 493.316775,202.907734 494,203.205054 L494,196.2 Z M486,197.8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.183a203a581adc16af0ddaa2e3bb92e4.svg";
export { ForwardRef as ReactComponent };